import React from 'react';
import PolicyLayout from '../components/PolicyLayout';

const ShippingPolicy: React.FC = () => {
  return (
    <PolicyLayout title="Shipping Policy" image="/images/fhome-ghee-grass.jpg">
      <p>
        Orders are shipped through registered domestic courier partners and/or speed post.
      </p>

      <h3>Dispatch Timeline</h3>
      <p>
        The product will be shipped within 2-3 days from order placement or payment confirmation,
        unless otherwise specified at checkout.
      </p>

      <h3>Delivery</h3>
      <ul>
        <li>Delivery is made to the address provided during purchase.</li>
        <li>The product will be delivered within 7 days from dispatch, subject to courier serviceability and location.</li>
        <li>Shipping charges, if applicable, are non-refundable.</li>
      </ul>
    </PolicyLayout>
  );
};

export default ShippingPolicy;
